import styled from "styled-components";
import { AppBar } from "discover.medical.react-component-library";
export const HeaderContainer = styled(AppBar.Container)`
  flex-shrink: 0;
`;

export const Logo = styled.img`
  vertical-align: middle;
  height: 1rem;

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.sm}) {
    height: 2.25rem;
  }

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.md}) {
    height: 2.5rem;
  }
`;
